import axios from "axios";
import { BXI_API_GATEWAY } from "../../../../env";

const Authorization = localStorage.getItem('access_token') ? JSON.parse(localStorage.getItem('access_token') || '') : ''; 
const access_uuid =  localStorage.getItem('access_uuid') ? JSON.parse(localStorage.getItem('access_uuid') || '') : '';  


const client = axios.create({
  baseURL: BXI_API_GATEWAY,
  headers: {
    "X-GeoPosition": "52.6522:-69.000",
    "X-CallerIP": "10.0.0.0",
    "Content-type": "application/json",
    Authorization: `Bearer ${Authorization}`,
    "process-id": `${access_uuid}`
  },
});

client.interceptors.response.use(
  (r) => r,
  (error) => {
    throw error;
  },
);
export default client;
